module.exports = __webpack_public_path__ + "static/media/PWID-T-03.59551159.png";